import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import useDebounce from '../hooks/useDebounce';

const Container = styled.div`
  display: inline-grid;
  grid-template-columns: repeat(${({ items }) => items}, 1fr);
  position: relative;
  background: #f1f2f5;
  border-radius: 8px;
  padding: 3px;
  vertical-align: middle;
`;

const Slider = styled.div`
  position: absolute;
  top: 3px;
  bottom: 3px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(14, 30, 64, 0.12);
  transition: left 0.25s ease;
  pointer-events: none;
`;

const Segment = styled.button`
  position: relative;
  z-index: 1;
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 7px 16px;
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  text-align: center;
  border-radius: 6px;
  color: ${({ active }) => (active ? '#0e1e40' : '#546077')};
  transition: color 0.2s ease;

  &:hover {
    color: #0e1e40;
  }
`;

function Toggle({ options = [], activeLabel, delay = 1000 }) {
  const initialIndex = Math.max(0, options.findIndex((o) => o.label === activeLabel));
  const [active, setActive] = useState(initialIndex);
  const { debounce } = useDebounce();
  const handleClick = debounce((onClick) => onClick(), delay);
  const items = options.length || 1;

  return (
    <Container items={items}>
      <Slider
        style={{
          width: `calc((100% - 6px) / ${items})`,
          left: `calc(3px + ((100% - 6px) / ${items}) * ${active})`,
        }}
      />
      {options.map(({ label, onClick }, index) => (
        <Segment
          key={label}
          type="button"
          active={active === index}
          onClick={() => {
            setActive(index);
            handleClick(onClick);
          }}
        >
          {label}
        </Segment>
      ))}
    </Container>
  );
}

Toggle.propTypes = {
  activeLabel: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }).isRequired).isRequired,
  delay: PropTypes.number,
};

export default Toggle;
